import qboLogo from "../../../assets/qbo_logo.svg";
import gearIcon from "../../../assets/gear_icon.svg";
import Hook from "./useHeader";
import { PrimaryButton, SecondaryButton } from "@moneris-portal/button";
import EligibilityModal from "../EligibilityModal";
import { SUBSCRIPTION_STATUS } from "../../../container/QBO_Accounting/constants";
import "./index.scss";

const Header = (props) => {
  const { isConnected, isLoading, subscription } = props;
  const {
    BLOCK,
    translate,
    connectLink,
    connectedLink,
    handleAccountSettings,
    handleConnectClick,
    eligibilityError,
    eligibilityLoading,
  } = Hook.useHeader(props);

  const status = subscription?.status;
  // User has access when connected OR has a subscription. If subscription exists, we assume user has access even if not currently connected, since they should be able to connect and get access immediately after. This also accounts for the case where subscription is active but connection is temporarily invalid (e.g. token expired) - user can just reconnect to regain access.
  const hasAccess = isConnected || subscription;

  // Show "Get Started" button when user has no access, or subscription is still in setup (PLAN_SELECTED / PENDING)
  const showGetStarted =
    !hasAccess || status === SUBSCRIPTION_STATUS.PLAN_SELECTED || status === SUBSCRIPTION_STATUS.PENDING;

  // AUTH_COMPLETE: subscription exists but QBO auth is pending — disable "Go to Quickbooks" button
  const isAuthComplete = hasAccess && status === SUBSCRIPTION_STATUS.AUTH_COMPLETE;

  // Disable buttons while data is still loading
  const buttonLoading = isLoading || eligibilityLoading;

  const Loader = (
    <div className={`${BLOCK.current}__loader-container loader_panel`}>
      <div className={`${BLOCK.current}__loader spinner`} />
    </div>
  );

  const GearIcon = (
    <img
      src={gearIcon}
      alt=""
      aria-hidden="true"
      className={`${BLOCK.current}__gear-icon`}
    />
  );

  // Not connected / no subscription / PLAN_SELECTED / PENDING → show "Get Started" only
  if (showGetStarted) {
    // Disable "Get Started" while loading or if eligibility check failed
    const primaryDisabled = buttonLoading || eligibilityError;
    return (
      <div className={BLOCK.current}>
        <EligibilityModal />
        <div className={`${BLOCK.current}__title`}>
          <img alt="Quickbooks logo" src={qboLogo} />
          <h1 className={`${BLOCK.current}__name`}>Quickbooks</h1>
        </div>
        <div className={`${BLOCK.current}__action`}>
          <a
            href={primaryDisabled ? undefined : connectLink}
            onClick={primaryDisabled ? (e) => e.preventDefault() : handleConnectClick}
            style={primaryDisabled ? { pointerEvents: "none" } : undefined}
          >
            <PrimaryButton
              isDisabled={primaryDisabled}
              title={buttonLoading ? Loader : translate("connect")}
            />
          </a>
        </div>
      </div>
    );
  }

  // Connected with active subscription → show "Account Settings" + "Go to Quickbooks"
  // Disable "Go to Quickbooks" while loading or when subscription is AUTH_COMPLETE (QBO auth still pending)
  const buttonDisabled = buttonLoading || isAuthComplete;
  return (
    <div className={BLOCK.current}>
      <EligibilityModal />
      <div className={`${BLOCK.current}__title`}>
        <img alt="Quickbooks logo" src={qboLogo} />
        <h1 className={`${BLOCK.current}__name`}>Quickbooks</h1>
      </div>
      <div className={`${BLOCK.current}__action`}>
        <SecondaryButton
          clickHandler={handleAccountSettings}
          isDisabled={buttonDisabled}
          title={translate("accountSettings")}
        >
          {GearIcon}
        </SecondaryButton>
        <a
          href={buttonDisabled ? undefined : connectedLink}
          style={buttonDisabled ? { pointerEvents: "none" } : undefined}
          target="_blank"
          rel="noopener noreferrer"
        >
          <PrimaryButton
            isDisabled={buttonDisabled}
            title={buttonLoading ? Loader : translate("connected")}
          />
        </a>
      </div>
    </div>
  );
};

export default Header;

